module.exports = __webpack_public_path__ + "static/media/diaper101-150.f062bc4b.png";